module.exports = __webpack_public_path__ + "img/castor.cc42f980.png";